const getDefaultState = () => {
  return {
    Campagnes: [],
    campagneActive: [],
    ArrayOfCampagnesActives: [],
    AnneesCampagnesActives: [],
    ProjetsOfCampagnesActives: [],
    startDate:null,
    endDate:null,
    collection: "campagnes",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.Campagnes = payload;
  },
  SET_CAMPAGNE_ACTIVE(state, payload) {
    state.campagneActive = payload;
  },

  SET_ARRAY_OF_CAMPAGNES_ACTIVES(state, payload) {
    //ArrayOfCampagnesActives
    let arr = [];
    payload.forEach(function (item) {
      arr.push(item.id);
    });
    state.ArrayOfCampagnesActives = arr;

    //ProjetsOfCampagnesActives
    let ProjetsOfCampagnesActives = [];
    payload.forEach(function (item) {
      ProjetsOfCampagnesActives.push(item.programme_id_programme);
    });
    state.ProjetsOfCampagnesActives = _.uniq(ProjetsOfCampagnesActives);

    //AnneesCampagnesActives
    let AnneesCampagnesActives = [];
    payload.forEach(function (item) {
      AnneesCampagnesActives.push(item.annee);
    });
    state.AnneesCampagnesActives = _.sortBy(_.uniq(AnneesCampagnesActives)); 


    state.startDate = AnneesCampagnesActives[0]+'-01-01';
    state.endDate = AnneesCampagnesActives.slice(-1)[0]+'-12-31';
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async GetAll({ commit, dispatch }) {
    // start requête
    commit("SET_LISTE", []);
    commit("Loading/START_BUSY_STATE", "Campagnes GetAll", { root: true });
    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.Campagnes.collection)
      .orderBy("ll_campagne", "asc")
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", null, { root: true });
          } else {
            console.log("tout est synchronisé Dans Campagnes GetAll");
            commit("Pending/END_PENDING_STATE", null, { root: true });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_LISTE", elems);
            //console.log("Campagnes:",elems)
            commit("Loading/END_BUSY_STATE", "Campagnes.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "Campagnes.store.js", {
            root: true,
          });
        }
      );
  },
  async GetCampagneActive({ commit, dispatch }) {
    // start requête
    commit("SET_CAMPAGNE_ACTIVE", []);
    commit("SET_ARRAY_OF_CAMPAGNES_ACTIVES", []);

    commit("Loading/START_BUSY_STATE", "Campagnes GetCampagneActive", {
      root: true,
    });

    let elems = [];
    await this._vm.$firebase
      .firestore()
      .collection(this.state.Campagnes.collection)
      .where("active", "==", "1")
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", null, { root: true });
          } else {
            console.log(
              "tout est synchronisé Dans Campagnes GetCampagneActive"
            );
            commit("Pending/END_PENDING_STATE", null, { root: true });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_CAMPAGNE_ACTIVE", elems);
            commit("SET_ARRAY_OF_CAMPAGNES_ACTIVES", elems);
            commit(
              "Loading/END_BUSY_STATE",
              "Campagnes.store.js GetCampagneActive",
              {
                root: true,
              }
            );
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit(
            "Loading/END_BUSY_STATE",
            "Campagnes.store.js GetCampagneActive",
            {
              root: true,
            }
          );
        }
      );
  },
};

const getters = {
  Campagnes: (state) => {
    return state.Campagnes;
  },
  campagneActive: (state) => {
    return state.campagneActive;
  },
  ArrayOfcampagnesActives: (state) => {
    return state.ArrayOfcampagnesActives;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
